import React, { Component } from "react";

import {ResourceUtil} from '../../uploadModal/file.type'

// import { Form,  message, Button, Icon } from 'antd';
import {Upload,message,Button,Icon} from "antd";
import { UploadFile, ShowUploadListInterface } from "antd/lib/upload/interface";
import UploadService from "../upload.service";

import SparkMD5 from 'spark-md5'

// interface Limit{
//     status: boolean,
//     typeLimit: string
// }

interface iProps {
    maxFileNumber?: number;
    maxFileLength?: number;
    minFileLength?: number;
    filePatten?: string;
    fileList?: any[];
    action?: string;
    disabled?: boolean;
    showUploadList?: boolean | ShowUploadListInterface;
    onChange?: (files: any[]) => void;
    children?: React.ReactNode;
    checkUploaderUrl?: string
    changeUploadDisableState?: (disableUploadState: boolean) => void,
    changeCurrentUploadFile?: (file: any) => void
}

let chunkList = []

export default class FileUpload extends Component<iProps> {
    private uploadService: UploadService = new UploadService();
    state: any = {
        OSSData: {},
        fileList: [],
        ossTypeEnum: '',
        filename: '',
        md5: null,
        uploadWay: '',
        etags: [],
        disableUploadState: false, // 上传状态，是否处于上传中
        currentUploadFile: {} // 当前正在上传中的文件
    };
    initFileList = (fileList = []) => {
        return fileList.map((file) => ({
        ...file,
        newUploadFlag:typeof file.newUploadFlag==='undefined'?false:file.newUploadFlag,
        url: file.fileUrl
        }));
    };
    componentDidMount() {
        const { fileList = [] } = this.props;
        this.setState({
        fileList: this.initFileList(fileList),
        });
    }
    componentWillReceiveProps(newProps) {
        const { fileList = [] } = newProps;
        this.setState({
            fileList: this.initFileList(fileList),
        });
    }
    getExtraData = (file) => {
        const { OSSData } = this.state;
        return {
            key: `${OSSData.dir}/${OSSData.fileId}`,
            AWSAccessKeyId: OSSData.accessid,
            // policy: OSSData.policy,
            signature: OSSData.signature,
            // 'X-Amz-Algorithm': OSSData.algorithm,
            // 'X-Amz-Credential': OSSData.credential,
            // 'X-Amz-Date': OSSData.date,
            // 'X-Amz-Signature': OSSData.signature
        };
    };
    transformFile = (file) => {
        const { OSSData } = this.state;
        const suffix = file.name.slice(file.name.lastIndexOf("."));
        // file.AWSAccessKeyId = OSSData.accessid
        // file.key = `/user/betty/${file.name}`
        // file.policy = OSSData.policy
        // file.signature = OSSData.signature
        return file;
    };
    showTime = (val: number) => {
        if(val<60){
            return val + "秒";
        }else{
            let min_total = Math.floor(val / 60); // 分钟
            let sec = Math.floor(val % 60); // 余秒
            if(min_total<60){
                return min_total + "分钟" + sec + "秒";
            }else{
                let hour_total = Math.floor(min_total / 60); // 小时数
                let min = Math.floor(min_total % 60); // 余分钟
                return hour_total + "小时" + min + "分钟" + sec + "秒";
            }
        }
    }
    // 改变上传组件的状态
    changeUploadComponentState = async (disableUploadState: boolean, uploadStatus?: string) => {
        this.setState({disableUploadState})
        this.props.changeUploadDisableState(disableUploadState)
        let currentUploadFile = JSON.parse(JSON.stringify(this.state.currentUploadFile))

        // 上传成功 释放上传按钮
        if (uploadStatus === 'successful' && !disableUploadState) {
            let commonFile = JSON.parse(JSON.stringify(this.state.fileList[0]))
            await this.props.changeCurrentUploadFile({...currentUploadFile, uploadStatus: 'successful', commonFile})
            this.props.onChange([])
            chunkList = []
            this.setState({etags: [], uploadWay: '',currentUploadFile: {}})
        } else if(uploadStatus === 'failed' && !disableUploadState) { // 上传失败 释放禁用按钮
            await this.props.changeCurrentUploadFile({...currentUploadFile, uploadStatus: 'failed'})
            this.props.onChange([])
            this.setState({etags: [], uploadWay: '',currentUploadFile: {}})
            chunkList = []
        }
    }
    // 通过文件后缀名获取fileType
    getFileType = (suffix) => {
        let type = ''
        for (let fileType in ResourceUtil.fileTypeMap) {
            if (ResourceUtil.fileTypeMap[fileType].indexOf(suffix) > -1) {
                type = fileType
                break
            }
        }
        return type
    }
    beforeUpload = (file) => {
        console.log(file)
        const suffix = file.name.slice(file.name.lastIndexOf(".")).split('.')[1]
        let fileType = this.getFileType(suffix)
        this.changeUploadComponentState(true)
        let duration = 0
        // 计算上传音视频时长
        if (fileType && (fileType === 'AUDIO' || fileType === 'VIDEO')) {
            let videoUrl = URL.createObjectURL(file)
            let videoaudio = document.createElement(fileType === 'VIDEO' ? 'video' : 'audio')
            videoaudio.setAttribute('src', videoUrl)
            videoaudio.oncanplay = () => {
                duration = Math.ceil(videoaudio.duration)
            }
        }
        // 视频音频最大5G 其他文件最大200M，另外也可以从外面传递进来
        let maxFileLength = this.props.maxFileLength ||((fileType === 'VIDEO' || fileType === 'AUDIO') ? 5120 : 200)
        let {
            minFileLength = 0.001,
            filePatten = 
            "(.mp4|.flv|.avi|.mov|.mkv|.m4v|.ts)$"
        } = this.props;
        if (filePatten&&!new RegExp(filePatten).test(file.name)) {
            message.warn(`文件类型无效！`);
            this.changeUploadComponentState(false)
            return false;
        }
        const isLtMaxFileLength = file.size / 1024 / 1024 < maxFileLength;
        if (!isLtMaxFileLength) {
            let size = null
            if (maxFileLength < 1024) {
                size = `${maxFileLength}MB`
            } else {
                size = `${(maxFileLength/ 1024).toFixed(1)}GB`
            }
            message.warn(`单个文件体积不能大于${size}`);
            this.changeUploadComponentState(false)
            return isLtMaxFileLength;
        }
        const isGtMaxFileLength = file.size / 1024 / 1024 > minFileLength;
        if (!isGtMaxFileLength) {
            message.warn(`单个文件体积不能小于1KB`);
            this.changeUploadComponentState(false)
            return isGtMaxFileLength;
        }
        return new Promise<void>(async (resolve, reject) => {
            try {
                // 通过文件类型获取上传类型
                let ossTypeEnum = await this.uploadService.checkUploader({url: this.props.checkUploaderUrl, type: fileType})
                await this.setState({ossTypeEnum})
                // 判断文件大小， 如果小于100MB，则使用普通上传，否则使用分段上传
                if ((file.size / 1024 / 1024) < 50) {
                    await this.setState({uploadWay: 'normal'})
                    let data = await this.uploadService.normalResourceSign(
                        {url:'/leco/ecology/api/v1/upload/sign', typeEnum: this.state.ossTypeEnum}
                    );
                    await this.setState({currentUploadFile: {
                        ...file,
                        ...data,
                        fileName: file.name,
                        uploadType: 'normal',
                        uploadStatus: 'pending',
                        suffix,
                        duration,
                        ossTypeEnum,
                        fileType
                    }})
                    this.props.changeCurrentUploadFile(this.state.currentUploadFile)
                    this.setState({ OSSData: data});
                } else {
                    await this.setState({uploadWay: 'split'})
                    const chunkSize = 50 * 1024 * 1024;
                    let partSize = Math.ceil(file.size / chunkSize); // 总片数
                    let data = await this.uploadService.splitUploadSign({url: '/leco/ecology/api/v1/upload/multiSign', typeEnum: this.state.ossTypeEnum, partSize})
                    await this.setState({ 
                        OSSData: data,
                        currentUploadFile: {
                            ...file,
                            ...data,
                            fileName: file.name,
                            uploadType: 'split',
                            suffix,
                            duration,
                            ossTypeEnum,
                            fileType
                        }
                    });
                }
                resolve();
            } catch (error) {
                this.changeUploadComponentState(false)
                reject();
            }
        });
    };
    /**
   * 计算md5，实现断点续传及秒传
   * @param file
   */
    computeMD5(file: any) {
        const _this = this
        this.setState({filename: file.name})
        return new Promise((resolve, reject)=>{
            try {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice
                // let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
                let currentChunk = 0; // 当前第几片
                const chunkSize = 50 * 1024 * 1024; // 每片的大小，这里是200M
                let chunks = Math.ceil(file.size / chunkSize); // 总片数
                let spark = new SparkMD5.ArrayBuffer();
                let start = currentChunk * chunkSize;
                let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                chunkList.push(blobSlice.call(file, start, end)) // 将每次分片的字节流放到数组里
                fileReader.onload = ((e: any) => {
                    spark.append(e.target.result);
                    currentChunk++;
                    if (currentChunk < chunks) {
                        let start = currentChunk * chunkSize;
                        let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
                        chunkList.push(blobSlice.call(file, start, end)) // 将每次分片的字节流放到数组里
                    } else {
                        let md5 = spark.end();
                        this.setState({md5: spark.end()})
                        resolve(md5)
                        // console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
                    }
                });
                fileReader.onerror = () => {
                    message.warn(`文件${file.name}读取出错，请检查该文件`);
                    this.changeUploadComponentState(false)
                    file.cancel();
                };
            }
            catch(e) {
                this.changeUploadComponentState(false)
                reject(e)
            }
        })
    }
    handleUpload = (param: any) => {
        const file = param.file
        let that = this
        if (this.state.uploadWay === 'split') {
            this.computeMD5(file).then((md5:any)=>{
                let etags = []
                const requestList = []
                if (chunkList.length > 0) {
                    for(let i = 0,len = chunkList.length;i<len;i++) {
                        const fn = () => {
                            return fetch(`${that.state.OSSData.urls[i]}`, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': "application/octet-stream"
                                },
                                body: chunkList[i]
                            }).then(result => {
                                if (result.status !== 200) {
                                    return Promise.reject()
                                } else {
                                    // 获取response中的etag
                                    let headers = result.headers
                                    etags.push(
                                            {
                                                eTag:JSON.parse(headers.get('ETag')),
                                                partNumber: i+1
                                            }
                                        )
                                    Promise.resolve()
                                }
                                
                            }).catch(err => {
                                // this.changeUploadComponentState(false, 'failed')
                                return Promise.reject(err)
                            })
                            // 这里请求checkFile，发送MD5返回是否已上传该片段，只不过我没写
                        }
                        requestList.push(fn)
                    }
                    let num = 0
                    // 本次分片上传是第几次（当某一分片上传失败之后，不能直接报错，而是再次上传此分片， 如果再次失败，则在进行一次，若第三次失败则不再进行重新上传）
                    let rank = 0
                    const send = async () => {
                        if (num >= requestList.length) {
                            // 请求完毕
                            await that.setState({etags})
                            that.splitComplete()
                            return
                        } else {
                            try {
                                await that.setState({
                                    currentUploadFile: 
                                        {
                                            ...that.state.currentUploadFile,
                                            totalRequest: requestList.length,
                                            completeRequest: num,
                                            uploadStatus: 'pending'
                                        }
                                })
                                that.props.changeCurrentUploadFile(that.state.currentUploadFile)
                                let data = await requestList[num]()
                                rank = 0
                                num++
                                send()
                            }catch {
                                rank++
                                if (rank < 3) { // 同一分片，若前两次上传失败，可进行第三次上传
                                    send()
                                } else {
                                    rank = 0
                                    message.error(`上传失败！`);
                                    that.setState({etags: []})
                                    this.changeUploadComponentState(false, 'failed')
                                    chunkList = []
                                }
                            }
                        }
                    }
                    send()
                }
            })
        } else if (this.state.uploadWay === 'normal') {
            fetch(this.state.OSSData.url, {
                method: 'PUT',
                headers: {
                    'Content-Type': "application/octet-stream"
                },
                body: file
            }).then(result => {
                if (result.status !== 200) {
                    message['error']('上传失败！')
                    this.changeUploadComponentState(false, 'failed')
                } else {
                    message['success']('上传完成！')
                    this.changeUploadComponentState(false, 'successful')
                }
            })
            .catch((err) => {
                message['error']('上传失败！')
                this.changeUploadComponentState(false, 'failed')
            })
        }
    }
    splitComplete = async() => {
        let params = {
            ossTypeEnum: this.state.ossTypeEnum,
            fileKey: `${this.state.OSSData.dir}/${this.state.OSSData.fileId}`,
            uploadId: this.state.OSSData.uploadId,
            etags: this.state.etags
        }
        try {
            let data = await this.uploadService.splitUploadComplete({url: '/leco/ecology/api/v1/upload/multiComplete', ...params})
            if (data) {
                message['success']('上传完成！')
                this.changeUploadComponentState(false, 'successful')
            }
        }catch {
            this.changeUploadComponentState(false, 'failed')
        }
        
    }
    handleChange = ({ fileList, file, event }) => {
        if (fileList[0].status === 'done') {
            this.changeUploadComponentState(false, 'successful')
        } else if (fileList[0].status === 'error') {
            this.changeUploadComponentState(false, 'failed')
        }
        const { onChange } = this.props;
        if (onChange) {
            onChange([...fileList]);
        }
    };
    render() {
        const {
            fileList=[],
            showUploadList = false,
            maxFileNumber = 100,
            children = "",
            filePatten = ""
        } = this.props;
        const {uploadWay,
            disableUploadState
        } = this.state
    return (
        <Upload
            name="file"
            accept={filePatten}
            multiple={false}
            // action={uploadWay === 'normal' ? this.state.OSSData.host : null}
            transformFile={this.transformFile}
            customRequest={this.handleUpload}
            fileList={fileList}
            showUploadList={showUploadList}
            beforeUpload={this.beforeUpload}
            onChange={this.handleChange}
            data={this.getExtraData}
        >
            {fileList.length < maxFileNumber && (
            <>
                {
                    children? children:
                    <Button type="primary" disabled={disableUploadState}>
                        <Icon type="upload" />
                        上传
                    </Button>
                }
            </>
            )}
        </Upload>
        );
    }
}
